import { Notif } from "../../components/notification";
import { user_routes as routes } from "../../constants/api-routes";
import { FormUtils } from "../../utils/_FormUtils";
import { API } from "../../utils/_HttpUtils";

const forget = (national_code) =>
    new API()
        .send("POST", routes.forget, {national_code}, FormUtils.captchaHeader())
        .then((response) => {
            if (response.data.result) {
                return Promise.resolve();
            }
            Notif.show("خطا در ارسال کد. لطفا دوباره تلاش کنید.", "warning");
            return Promise.reject();
        });

export default forget;
export { forget };
